<template>
  <modal
    name="modal--edit-product-categories"
    transition="nice-modal-fade"
    :click-to-close="false"
    :width="400"
    :height="'auto'"
    :adaptive="true"
    :reset="true"
    :scrollable="true"
    draggable=".drag-handler"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    class="py-10"
  >
    <div
      class="flex flex-col text-black h-full overflow-hidden w-full bg-white rounded-sm justify-between p-4"
    >
      <div
        class="text-center text-3xl mb-4 mt-4 font-extralight tracking-tight drag-handler"
      >
        Product Expense Categories
      </div>

      <div class="text-xl">
        <form @submit.prevent="handleConfirm">
          <todo-list
            ref="productExpenseCategoryList"
            :label="''"
            placeholder="Add Category"
            :validation-type="'text'"
            :list="data.productExpenseCategories"
            :readonly="!isAdmin"
            @add="add"
            @remove="remove"
            class="text-base font-normal normal-case"
          />
          <div class="button-set flex flex-row justify-between mt-10">
            <button
              class="buttonOutline focus:shadow-outline focus:outline-none"
              @click.prevent="$modal.hide('modal--edit-product-categories')"
            >
              Cancel
            </button>

            <button
              v-if="isAdmin"
              class="button focus:shadow-outline focus:outline-none"
              type="submit"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import { productCategories } from '@/const.js'
import TodoList from '@/components/TodoList'

export default {
  name: 'ModalEditProductCategories',
  data() {
    return {
      data: {
        productExpenseCategories: []
      }
    }
  },
  components: {
    TodoList
  },
  computed: {
    ...mapGetters('global', {
      productExpenseCategories: 'settingsProductExpenseCategories'
    }),
    ...mapGetters('user', ['isAdmin'])
  },
  methods: {
    ...mapActions('config', ['setFabVisible', 'setDragLock']),
    ...mapActions('global', ['updateSettings']),
    beforeOpen() {
      this.data.productExpenseCategories = [
        ...(this.productExpenseCategories || [])
      ]
      this.setFabVisible(false)
      this.setDragLock(true)
    },
    beforeClose() {
      this.setFabVisible(true)
      this.setDragLock(false)
    },
    add(i) {
      this.data.productExpenseCategories.push(i)
    },
    remove(i) {
      let index = this.data.productExpenseCategories.indexOf(i)
      if (index > -1) this.data.productExpenseCategories.splice(index, 1)
    },
    handleConfirm() {
      if (this.productExpenseCategories != this.data.productExpenseCategories) {
        this.updateSettings({
          productExpenseCategories: this.data.productExpenseCategories
        })
      }
      this.$modal.hide('modal--edit-product-categories')
    }
  }
}
</script>
